(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rd-audit-size-labels"]) return;
  try {
    

  if (!customElements.get('rd-audit-size-labels')) {
    customElements.define('rd-audit-size-labels', class extends HTMLElement {
      connectedCallback() {
        if (this.observer || !['16192739279173','16193988034885'].includes(this.dataset.productId)) return;
        this.root = this.closest('main');
        if (!this.root) return;
        try {
          this.mapping = JSON.parse(this.querySelector('[data-rd-audit-size-map]').textContent)[this.dataset.productId];
          if (Object.keys(this.mapping).length !== 5) return;
          this.originalLabels = new Map();
          this.note = this.querySelector('template').content.firstElementChild.cloneNode(true);
          this.observer = new MutationObserver(() => this.refresh());
          this.observer.observe(this.root, { childList: true, subtree: true, characterData: true });
          this.refresh();
        } catch {
          this.disconnectedCallback();
        }
      }

      refresh() {
        const productInfo = this.root.querySelector(`product-info[data-product-id="${this.dataset.productId}"]`);
        const picker = [...(productInfo?.querySelectorAll('variant-selects') || [])].find(item => !item.hidden && item.style.display !== 'none');
        const size = picker?.querySelector('select[name="options[Size]"]');
        const options = [...(size?.options || [])];
        const group = size?.closest('.product-form__input');
        const valid = group && options.length === 5 && new Set(options.map(option => option.value)).size === 5 && options.every(option => option.hasAttribute('value') && option.dataset.optionValueId && Object.hasOwn(this.mapping, option.value));
        if (!valid) {
          this.restoreLabels();
          this.note?.remove();
          delete this.dataset.ready;
          return;
        }
        for (const [option] of this.originalLabels) {
          if (!options.includes(option)) {
            this.restoreLabel(option);
            this.originalLabels.delete(option);
          }
        }
        for (const option of options) {
          const label = this.mapping[option.value];
          if (!this.originalLabels.has(option)) this.originalLabels.set(option, option.textContent);
          if (option.textContent !== label) option.textContent = label;
        }
        if (this.note.parentElement !== group) group.append(this.note);
        this.dataset.ready = 'true';
      }

      restoreLabel(option) {
        const original = this.originalLabels.get(option);
        if (option.textContent === this.mapping[option.value] && option.textContent !== original) option.textContent = original;
      }

      restoreLabels() {
        for (const [option] of this.originalLabels || []) this.restoreLabel(option);
        this.originalLabels?.clear();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.observer = null;
        this.restoreLabels();
        this.note?.remove();
        delete this.dataset.ready;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rd-chart-colour-swatches"]) return;
  try {
    

if (!customElements.get('rd-chart-colour-swatches')) {
  customElements.define('rd-chart-colour-swatches', class extends HTMLElement {
    async connectedCallback() {
      if (this.started) return;
      this.started = true;
      const run = this.run = (this.run || 0) + 1;
      try {
        this.manifest = JSON.parse(this.querySelector('[data-rd-chart-map]').textContent);
        if (this.manifest.length !== 50 || new Set(this.manifest.map(item => item.name)).size !== 50) return;
        const chartUrl = new URL(this.dataset.chartUrl, document.baseURI);
        if (chartUrl.protocol !== 'https:') return;
        await Promise.all([
          customElements.whenDefined('variant-selects'),
          customElements.whenDefined('product-info'),
          new Promise((resolve, reject) => {
            const chart = new Image();
            chart.onload = () => chart.naturalWidth === 2500 && chart.naturalHeight === 3500 ? resolve() : reject(new Error('Chart dimensions'));
            chart.onerror = reject;
            chart.src = chartUrl.href;
          })
        ]);
        if (!this.isConnected || run !== this.run) return;
        this.productInfo = [...(this.closest('main') || document).querySelectorAll('product-info')].find(info => info.dataset.productId === this.dataset.productId);
        if (!this.productInfo || this.productInfo.querySelector('[data-rd-chart-controls]')) return;
        this.controls = this.querySelector('template').content.firstElementChild.cloneNode(true);
        this.grid = this.controls.querySelector('[data-rd-chart-grid]');
        this.selectedName = this.controls.querySelector('[data-rd-chart-selected]');
        this.dropdown = this.controls.querySelector('[data-rd-colour-dropdown]');
        this.summary = this.dropdown.querySelector('summary');
        this.selectedSample = this.controls.querySelector('[data-rd-selected-sample]');
        this.selectedFinishes = this.controls.querySelector('[data-rd-selected-finishes]');
        this.finishDescription = item => item.finishes.length === 2 ? 'Matt & Gloss' : item.finishes[0] === 'Matte' ? 'Matt only' : 'Gloss only';
        this.radios = new Map();
        for (const [index, item] of this.manifest.entries()) {
          const label = document.createElement('label');
          label.className = 'rd-chart-swatches__choice';
          label.title = `${item.name} — ${this.finishDescription(item)}`;
          const radio = document.createElement('input');
          radio.type = 'radio';
          radio.name = `rd-chart-colour-${this.dataset.instance}`;
          radio.id = `${radio.name}-${index}`;
          radio.value = item.name;
          radio.className = 'rd-chart-swatches__input';
          radio.setAttribute('aria-label', `${item.name} — ${this.finishDescription(item)}`);
          const tile = document.createElement('span');
          tile.className = 'rd-chart-swatches__tile';
          tile.setAttribute('aria-hidden', 'true');
          const sample = document.createElement('span');
          sample.className = 'rd-chart-swatches__sample';
          sample.style.backgroundImage = `url("${chartUrl.href}")`;
          sample.style.backgroundPosition = `${(item.square[0] / 2400) * 100}% ${(item.square[1] / 3400) * 100}%`;
          tile.append(sample);
          const text = document.createElement('span');
          text.className = 'rd-chart-swatches__text';
          text.setAttribute('aria-hidden', 'true');
          const name = document.createElement('span');
          name.className = 'rd-chart-swatches__name';
          name.textContent = item.name;
          const availability = document.createElement('span');
          availability.className = 'rd-chart-swatches__availability';
          availability.textContent = this.finishDescription(item);
          text.append(name, availability);
          label.append(radio, tile, text);
          this.grid.append(label);
          this.radios.set(item.name, radio);
        }
        this.closeDropdown = (restoreFocus = false) => {
          this.dropdown.open = false;
          if (restoreFocus) this.summary.focus({ preventScroll: true });
        };
        this.controls.addEventListener('click', event => {
          const choice = event.target.closest('.rd-chart-swatches__choice');
          const radio = choice?.querySelector('.rd-chart-swatches__input');
          if (!radio || radio.disabled || this.dataset.ready !== 'true') return;
          event.preventDefault();
          event.stopPropagation();
          this.colour.value = radio.value;
          this.colour.dispatchEvent(new Event('change', { bubbles: true }));
          this.sync();
          this.closeDropdown(true);
        });
        this.controls.addEventListener('keydown', event => {
          if (event.key === 'Escape' || (event.key === 'Enter' && event.target.matches('.rd-chart-swatches__input'))) {
            event.preventDefault();
            this.closeDropdown(true);
          }
        });
        this.onOutsideClick = event => {
          if (!this.controls.contains(event.target)) this.closeDropdown();
        };
        document.addEventListener('click', this.onOutsideClick);
        this.controls.addEventListener('change', event => {
          const radio = event.target;
          if (this.dataset.ready !== 'true' || this.radios.get(radio.value) !== radio || !radio.checked) return;
          event.stopPropagation();
          this.colour.value = radio.value;
          this.colour.dispatchEvent(new Event('change', { bubbles: true }));
          this.sync();
        });
        this.onNativeChange = event => {
          if (event.target === this.colour) this.sync();
        };
        this.productInfo.addEventListener('change', this.onNativeChange);
        this.observer = new MutationObserver(() => this.refresh());
        this.observer.observe(this.productInfo, { childList: true, subtree: true });
        this.refresh();
      } catch {
        if (run === this.run) this.fallback();
      }
    }

    disconnectedCallback() {
      this.run = (this.run || 0) + 1;
      this.observer?.disconnect();
      this.productInfo?.removeEventListener('change', this.onNativeChange);
      document.removeEventListener('click', this.onOutsideClick);
      this.fallback();
      this.controls?.remove();
      this.started = false;
      this.picker = null;
      this.colour = null;
    }

    refresh() {
      const picker = [...this.productInfo.querySelectorAll('variant-selects')].find(item => item.style.display !== 'none' && !item.hidden);
      const colour = picker?.querySelector('select[name="options[Colour]"]');
      if (picker === this.picker && colour === this.colour) return;
      const options = [...(colour?.options || [])];
      const names = options.map(option => option.value);
      const group = colour?.closest('.product-form__input');
      if (!picker || !colour || !group || options.length !== 50 || new Set(names).size !== 50 || names.some(name => !this.radios.has(name)) || options.some(option => !option.dataset.optionValueId) || !this.radios.has(colour.value)) {
        this.fallback();
        this.picker = picker;
        this.colour = colour;
        return;
      }
      const active = document.activeElement;
      const wasSwatch = this.controls.contains(active);
      const preserveFocus = wasSwatch ? active.value : null;
      this.restoreNative();
      this.picker = picker;
      this.colour = colour;
      this.nativeGroup = group;
      this.nativeWasHidden = group.hidden;
      this.controls.hidden = false;
      if (picker.nextElementSibling !== this.controls) picker.after(this.controls);
      group.setAttribute('data-rd-native-chart-colour', '');
      group.hidden = true;
      this.dataset.ready = 'true';
      this.sync();
      if (preserveFocus) this.radios.get(preserveFocus)?.focus({ preventScroll: true });
    }

    sync() {
      if (this.dataset.ready !== 'true') return;
      const options = new Map([...this.colour.options].map(option => [option.value, option]));
      for (const [name, radio] of this.radios) {
        radio.checked = name === this.colour.value;
        radio.disabled = options.get(name)?.disabled || false;
      }
      if (this.selectedName.textContent !== this.colour.value) this.selectedName.textContent = this.colour.value;
      const item = this.manifest.find(entry => entry.name === this.colour.value);
      if (item) {
        const source = this.radios.get(item.name).parentElement.querySelector('.rd-chart-swatches__sample');
        this.selectedSample.style.backgroundImage = source.style.backgroundImage;
        this.selectedSample.style.backgroundPosition = source.style.backgroundPosition;
        const description = this.finishDescription(item);
        if (this.selectedFinishes.textContent !== description) this.selectedFinishes.textContent = description;
      }
    }

    restoreNative() {
      if (!this.nativeGroup) return;
      this.nativeGroup.hidden = this.nativeWasHidden;
      this.nativeGroup.removeAttribute('data-rd-native-chart-colour');
      this.nativeGroup = null;
    }

    fallback() {
      this.restoreNative();
      for (const group of this.productInfo?.querySelectorAll('[data-rd-native-chart-colour]') || []) {
        group.hidden = false;
        group.removeAttribute('data-rd-native-chart-colour');
      }
      if (this.controls) this.controls.hidden = true;
      delete this.dataset.ready;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rd-flower-four-selectors"]) return;
  try {
    

  if (!customElements.get('rd-flower-four-selectors')) {
    customElements.define('rd-flower-four-selectors', class extends HTMLElement {
      async connectedCallback() {
        if (this.started) return;
        this.started = true;
        await Promise.all([customElements.whenDefined('variant-selects'), customElements.whenDefined('product-info')]);
        if (!this.isConnected) return;
        try {
          this.mapping = JSON.parse(this.querySelector('[data-rd-flower-map]').textContent);
          this.productInfo = this.closest('main')?.querySelector(`product-info[data-product-id="${this.dataset.productId}"]`);
          if (!this.productInfo || this.dataset.productId !== '16192739279173') return;
          this.controls = this.querySelector('[data-rd-flower-controls]').content.firstElementChild.cloneNode(true);
          this.finish = this.controls.querySelector('[data-rd-finish]');
          this.direction = this.controls.querySelector('[data-rd-direction]');
          this.note = this.controls.querySelector('[data-rd-finish-note]');
          this.onChange = this.handleChange.bind(this);
          this.productInfo.addEventListener('change', this.onChange, true);
          this.observer = new MutationObserver(() => this.refresh());
          this.observer.observe(this.productInfo, { childList: true, subtree: true });
          this.preservePreviewRoute();
          this.refresh();
        } catch {
          this.fallback();
        }
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.productInfo?.removeEventListener('change', this.onChange, true);
        this.fallback();
        this.controls?.remove();
        if (this.restoreRoute) this.restoreRoute();
        this.started = false;
      }

      preservePreviewRoute() {
        const owner = this;
        const originalRequest = this.productInfo.buildRequestUrlWithParams;
        const originalUpdate = this.productInfo.updateURL;
        this.productInfo.buildRequestUrlWithParams = function (url, optionValues, fullPage = false) {
          const result = new URL(window.location.href);
          result.searchParams.delete('variant');
          result.searchParams.delete('option_values');
          result.searchParams.delete('section_id');
          if (!fullPage) result.searchParams.set('section_id', this.sectionId);
          if (optionValues.length) result.searchParams.set('option_values', optionValues.join(','));
          return result.pathname + result.search;
        };
        this.productInfo.updateURL = function (url, variantId) {
          if (this.dataset.updateUrl === 'false') return;
          const result = new URL(window.location.href);
          result.searchParams.delete('option_values');
          result.searchParams.delete('section_id');
          if (variantId) result.searchParams.set('variant', variantId);
          else result.searchParams.delete('variant');
          window.history.replaceState({}, '', result.pathname + result.search + result.hash);
        };
        this.restoreRoute = () => {
          owner.productInfo.buildRequestUrlWithParams = originalRequest;
          owner.productInfo.updateURL = originalUpdate;
        };
      }

      refresh() {
        const picker = this.productInfo.querySelector('variant-selects:not([style*="display: none"])');
        if (picker === this.picker) return;
        this.fallback();
        this.picker = picker;
        if (!picker) return;
        const selects = [...picker.querySelectorAll('select')];
        if (selects.length !== 3 || selects[0].name !== 'options[Size]' || selects[1].name !== 'options[Colour]' || selects[2].name !== 'options[Finish and image direction]') return;
        [this.size, this.colour, this.combined] = selects;
        const colours = [...this.colour.options].map(option => option.value);
        const combinations = [...this.combined.options].map(option => option.value);
        if (colours.length !== 50 || colours.some(colour => !Object.hasOwn(this.mapping, colour))) return;
        if (combinations.length !== 4 || combinations.some(value => !/^(Matte|Gloss) - (Standard|Mirrored)$/.test(value))) return;
        if (selects.some(select => [...select.options].some(option => !option.dataset.optionValueId))) return;
        const split = this.combined.value.split(' - ');
        if (split.length !== 2 || !this.mapping[this.colour.value]?.includes(split[0])) return;
        this.combinedGroup = this.combined.closest('.product-form__input');
        if (!this.combinedGroup) return;
        this.finish.value = split[0];
        this.direction.value = split[1];
        this.updateFinishes();
        this.picker.after(this.controls);
        this.combinedGroup.setAttribute('data-rd-native-combined', '');
        this.combinedGroup.hidden = true;
        this.controls.hidden = false;
        this.dataset.ready = 'true';
        this.enhanceDescription();
      }

      enhanceDescription() {
        const description = this.productInfo.querySelector('.product__description');
        if (!description) return;
        const originalSentence = 'Choose your size, colour, then finish and image direction using the three menus.';
        const updatedSentence = 'Choose your size, colour, finish and image direction using the four options.';
        const nodes = document.createTreeWalker(description, NodeFilter.SHOW_TEXT);
        while (nodes.nextNode()) {
          const node = nodes.currentNode;
          if (!node.data.includes(originalSentence)) continue;
          this.descriptionChange = { node, original: node.data, updated: node.data.replace(originalSentence, updatedSentence) };
          node.data = this.descriptionChange.updated;
          return;
        }
      }

      fallback() {
        for (const group of this.productInfo?.querySelectorAll('[data-rd-native-combined]') || []) {
          group.hidden = false;
          group.removeAttribute('data-rd-native-combined');
        }
        if (this.controls) this.controls.hidden = true;
        delete this.dataset.ready;
        if (this.descriptionChange) {
          const { node, original, updated } = this.descriptionChange;
          if (node.data === updated) node.data = original;
          this.descriptionChange = null;
        }
      }

      updateFinishes() {
        const valid = this.mapping[this.colour.value];
        if (!valid) return false;
        for (const option of this.finish.options) option.disabled = !valid.includes(option.value);
        this.note.hidden = valid.length === 2;
        if (!valid.includes(this.finish.value)) this.finish.value = valid[0];
        return true;
      }

      handleChange(event) {
        if (this.dataset.ready !== 'true') return;
        if (event.target === this.colour) {
          if (!this.updateFinishes()) return this.fallback();
          this.combined.value = `${this.finish.value} - ${this.direction.value}`;
          for (const option of this.combined.options) {
            if (option.value === this.combined.value) option.setAttribute('selected', 'selected');
            else option.removeAttribute('selected');
          }
          return;
        }
        if (event.target !== this.finish && event.target !== this.direction) return;
        event.stopPropagation();
        const valid = this.mapping[this.colour.value];
        if (!valid?.includes(this.finish.value) || !['Standard', 'Mirrored'].includes(this.direction.value)) return this.fallback();
        this.combined.value = `${this.finish.value} - ${this.direction.value}`;
        if (!this.combined.value) return this.fallback();
        this.combined.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rd-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rd-gallery-category')) {
    customElements.define('rd-gallery-category', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        clearTimeout(this.timer);
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.slides = [...this.querySelectorAll('.rd-gallery__cover')];
        this.dots = [...this.querySelectorAll('.rd-gallery__dot')];
        this.button = this.querySelector('.rd-gallery__pause');
        if (this.slides.length < 2 || !this.button) return;
        this.index = Math.max(0, this.slides.findIndex(slide => slide.classList.contains('is-active')));
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.motion.matches;
        this.visible = false;
        this.hoverPaused = false;
        this.focusPaused = false;
        this.button.hidden = false;
        this.updateButton();
        this.button.addEventListener('click', () => { this.paused = !this.paused; if (!this.paused) { this.hoverPaused = false; this.focusPaused = false; } this.updateButton(); this.schedule(); }, options);
        this.addEventListener('mouseenter', () => { this.hoverPaused = true; this.schedule(); }, options);
        this.addEventListener('mouseleave', () => { this.hoverPaused = false; this.schedule(); }, options);
        this.addEventListener('focusin', () => { this.focusPaused = true; this.schedule(); }, options);
        this.addEventListener('focusout', () => setTimeout(() => { if (this.isConnected) { this.focusPaused = this.contains(document.activeElement); this.schedule(); } }, 0), options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.motion.addEventListener('change', () => { this.paused = this.motion.matches; this.updateButton(); this.schedule(); }, options);
        this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.schedule(); }, { threshold: 0.2 });
        this.observer.observe(this);
      }
      updateButton() {
        this.button.setAttribute('aria-pressed', String(this.paused));
        this.button.setAttribute('aria-label', (this.paused ? this.dataset.playLabel : this.dataset.pauseLabel) + ': ' + this.button.dataset.heading);
        this.button.querySelector('span').textContent = this.paused ? '▶' : '❚❚';
      }
      canPlay() { return this.isConnected && this.visible && !this.paused && !document.hidden && !this.hoverPaused && !this.focusPaused; }
      schedule() {
        clearTimeout(this.timer);
        if (!this.canPlay()) return;
        this.timer = setTimeout(async () => {
          const next = (this.index + 1) % this.slides.length;
          const image = this.slides[next];
          try { await image.decode(); } catch { this.schedule(); return; }
          if (!this.canPlay()) return;
          this.slides[this.index].classList.remove('is-active');
          this.dots[this.index]?.classList.remove('is-active');
          image.classList.add('is-active');
          this.dots[next]?.classList.add('is-active');
          this.index = next;
          this.schedule();
        }, 5200 + Number(this.dataset.offset || 0));
      }
      disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); clearTimeout(this.timer); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rd-gothic-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rd-gothic-collection')) {
    customElements.define('rd-gothic-collection', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.filters = this.querySelector('.rd-gothic__filters');
        this.buttons = Array.from(this.querySelectorAll('[data-filter]'));
        this.cards = Array.from(this.querySelectorAll('[data-category]'));
        this.counter = this.querySelector('.rd-gothic__count');
        this.buttons.forEach(button => button.addEventListener('click', () => this.filter(button.dataset.filter), options));
        this.addEventListener('shopify:block:select', event => {
          const card = event.target.closest('[data-category]');
          if (card) this.filter('all');
        }, options);
        if (this.filters) this.filters.hidden = false;
      }
      filter(category) {
        this.buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === category)));
        let count = 0;
        this.cards.forEach(card => {
          card.hidden = category !== 'all' && card.dataset.category !== category;
          if (!card.hidden) count += 1;
        });
        if (this.counter) this.counter.textContent = this.dataset.countTemplate.replace('[count]', String(count));
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rd-home-welcome"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rd-home-showcase')) {
    customElements.define('rd-home-showcase', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.slides = Array.from(this.querySelectorAll('[data-showcase-slide], template[data-showcase-template]'));
        if (this.slides.length < 2) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.track = this.querySelector('[data-showcase-track]');
        this.count = this.querySelector('[data-showcase-count]');
        this.toggleIcon = this.querySelector('[data-showcase-toggle-icon]');
        this.toggleLabel = this.querySelector('[data-showcase-toggle-label]');
        this.toggle = this.querySelector('[data-showcase-toggle]');
        this.jump = this.querySelector('[data-showcase-jump]');
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.paused = this.motion.matches || this.mobile.matches;
        this.hovered = false;
        this.focused = this.contains(document.activeElement);
        this.playThroughFocus = false;
        this.playThroughHover = false;
        this.visible = false;
        this.index = Math.max(0, this.slides.findIndex((slide) => !slide.hidden));
        this.reserveCaptionHeight();
        this.querySelector('[data-showcase-controls]').hidden = false;
        if (this.slides.length > 6 && this.jump) {
          this.jump.replaceChildren(...this.slides.map((slide, index) => {
            const option = document.createElement('option');
            option.value = String(index);
            option.textContent = this.dataset.reviewLabel.replace('[number]', String(index + 1));
            return option;
          }));
          this.querySelector('[data-showcase-jump-wrapper]').hidden = false;
          this.jump.addEventListener('change', () => {
            this.paused = true;
            this.show(Number(this.jump.value));
            this.update();
          }, options);
        }
        this.querySelector('[data-showcase-previous]').addEventListener('click', () => this.move(-1, true), options);
        this.querySelector('[data-showcase-next]').addEventListener('click', () => this.move(1, true), options);
        this.toggle.addEventListener('click', () => {
          this.paused = !this.paused;
          this.playThroughFocus = !this.paused && document.activeElement === this.toggle;
          this.playThroughHover = !this.paused && this.toggle.matches(':hover');
          this.update();
        }, options);
        this.addEventListener('pointerenter', (event) => {
          if (event.pointerType === 'mouse' || event.pointerType === 'pen') {
            this.hovered = true;
            this.update();
          }
        }, options);
        this.addEventListener('pointerover', (event) => {
          if (this.playThroughHover && !this.toggle.contains(event.target)) {
            this.playThroughHover = false;
            this.update();
          }
        }, options);
        this.addEventListener('pointerleave', () => {
          this.hovered = false;
          this.playThroughHover = false;
          this.update();
        }, options);
        this.addEventListener('focusin', () => {
          this.focused = true;
          this.playThroughFocus = false;
          this.update();
        }, options);
        this.addEventListener('focusout', (event) => {
          this.focused = this.contains(event.relatedTarget);
          this.playThroughFocus = false;
          this.update();
        }, options);
        this.track.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'mouse') this.swipeStart = { x: event.clientX, y: event.clientY };
        }, options);
        this.track.addEventListener('pointerup', (event) => {
          if (!this.swipeStart) return;
          const deltaX = event.clientX - this.swipeStart.x;
          const deltaY = event.clientY - this.swipeStart.y;
          this.swipeStart = null;
          if (Math.abs(deltaX) > 45 && Math.abs(deltaX) > Math.abs(deltaY) * 1.4) this.move(deltaX < 0 ? 1 : -1, true);
        }, options);
        this.track.addEventListener('pointercancel', () => { this.swipeStart = null; }, options);
        this.mobile.addEventListener('change', (event) => {
          if (event.matches) this.paused = true;
          this.update();
        }, options);
        document.addEventListener('visibilitychange', () => this.update(), options);
        this.motion.addEventListener('change', (event) => {
          if (event.matches) this.paused = true;
          this.update();
        }, options);
        this.addEventListener('shopify:block:select', (event) => {
          const selected = this.slides.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);
          if (selected < 0) return;
          this.paused = true;
          this.show(selected);
          this.update();
        }, options);
        this.observer = new IntersectionObserver((entries) => {
          this.visible = entries.some((entry) => entry.isIntersecting && entry.intersectionRatio >= .15);
          this.update();
        }, { threshold: 0.15 });
        this.observer.observe(this);
        this.show(this.index);
        this.update();
      }

      reserveCaptionHeight() {
        this.captionSizer = document.createElement('div');
        this.captionSizer.className = 'rd-home__caption-measure';
        this.captionSizer.setAttribute('aria-hidden', 'true');
        this.captionSizer.inert = true;
        this.slides.forEach((entry) => {
          const slide = entry.tagName === 'TEMPLATE' ? entry.content.firstElementChild : entry;
          const caption = slide.querySelector('figcaption');
          if (!caption) return;
          const sample = document.createElement('figure');
          sample.className = slide.className.replace('rd-home__showcase-slide', '').trim();
          sample.append(caption.cloneNode(true));
          this.captionSizer.append(sample);
        });
        this.track.append(this.captionSizer);
        const resize = () => {
          const height = Math.ceil(this.captionSizer.getBoundingClientRect().height);
          if (height > 0) this.track.style.setProperty('--rd-review-caption-height', `${height}px`);
        };
        this.captionObserver = new ResizeObserver(resize);
        this.captionObserver.observe(this.captionSizer);
        resize();
      }

      show(index) {
        this.index = (index + this.slides.length) % this.slides.length;
        const selected = this.slides[this.index];
        if (selected.tagName === 'TEMPLATE') {
          const slide = selected.content.firstElementChild.cloneNode(true);
          this.slides[this.index] = slide;
          selected.replaceWith(slide);
        }
        this.slides.forEach((slide, slideIndex) => {
          if (slide.tagName === 'TEMPLATE') return;
          const inactive = slideIndex !== this.index;
          slide.hidden = inactive;
          slide.inert = inactive;
          if (inactive) slide.setAttribute('aria-hidden', 'true');
          else slide.removeAttribute('aria-hidden');
        });
        this.count.textContent = `${this.index + 1} / ${this.slides.length}`;
        this.count.setAttribute('aria-label', this.dataset.positionLabel.replace('[number]', String(this.index + 1)).replace('[total]', String(this.slides.length)));
        if (this.jump) this.jump.value = String(this.index);
      }

      move(direction, manual) {
        if (manual) this.paused = true;
        this.show(this.index + direction);
        this.update();
      }

      update() {
        window.clearTimeout(this.timer);
        const focusBlocked = this.focused && !(this.playThroughFocus && document.activeElement === this.toggle);
        const hoverBlocked = this.hovered && !this.playThroughHover;
        const stopped = this.paused || this.mobile.matches || this.motion.matches;
        this.toggleLabel.textContent = stopped ? this.dataset.playLabel : this.dataset.pauseLabel;
        this.toggleIcon.textContent = stopped ? '▶' : 'Ⅱ';
        this.track.setAttribute('aria-live', stopped || focusBlocked || hoverBlocked ? 'polite' : 'off');
        if (stopped || focusBlocked || hoverBlocked || !this.visible || document.hidden) return;
        this.timer = window.setTimeout(() => this.move(1, false), 9000);
      }

      disconnectedCallback() {
        window.clearTimeout(this.timer);
        this.controller?.abort();
        this.observer?.disconnect();
        this.captionObserver?.disconnect();
        this.captionSizer?.remove();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rd-shop-designs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rd-design-collection')) {
    customElements.define('rd-design-collection', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        clearTimeout(this.timer);
        this.generation = (this.generation || 0) + 1;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.slides = [...this.querySelectorAll('.rd-designs__image')];
        this.dots = [...this.querySelectorAll('.rd-designs__dot')];
        this.button = this.querySelector('.rd-designs__pause');
        if (this.slides.length < 2 || !this.button) return;
        this.index = Math.max(0, this.slides.findIndex(slide => slide.classList.contains('is-active')));
        this.failed = new Set();
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.motion.matches;
        this.hoverPaused = false;
        this.visible = false;
        this.button.hidden = false;
        this.querySelector('.rd-designs__dots').hidden = false;
        this.updateButton();
        this.button.addEventListener('pointerdown', () => { this.pointerPaused = !this.paused; }, options);
        this.button.addEventListener('click', event => {
          this.paused = event.detail > 0 && typeof this.pointerPaused === 'boolean' ? this.pointerPaused : !this.paused;
          this.pointerPaused = undefined;
          if (!this.paused) this.hoverPaused = false;
          this.updateButton();
          this.schedule();
        }, options);
        this.addEventListener('mouseenter', () => { this.hoverPaused = true; this.schedule(); }, options);
        this.addEventListener('mouseleave', () => { this.hoverPaused = false; this.schedule(); }, options);
        this.addEventListener('focusin', () => {
          this.paused = true;
          this.updateButton();
          this.schedule();
        }, options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.motion.addEventListener('change', () => {
          if (this.motion.matches) this.paused = true;
          this.updateButton();
          this.schedule();
        }, options);
        this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.schedule(); }, { threshold: 0.2 });
        this.observer.observe(this);
      }
      updateButton() {
        this.button.setAttribute('aria-label', (this.paused ? this.dataset.playLabel : this.dataset.pauseLabel) + ': ' + this.dataset.title);
        this.button.querySelector('span').textContent = this.paused ? '▶' : '❚❚';
      }
      canPlay() { return this.isConnected && this.visible && !this.paused && !document.hidden && !this.hoverPaused; }
      schedule() {
        clearTimeout(this.timer);
        const generation = ++this.generation;
        if (!this.canPlay()) return;
        this.timer = setTimeout(() => this.advance(generation), 5200 + Number(this.dataset.offset || 0));
      }
      async advance(generation) {
        for (let step = 1; step < this.slides.length; step += 1) {
          const next = (this.index + step) % this.slides.length;
          if (this.failed.has(next)) continue;
          try { await this.slides[next].decode(); }
          catch {
            if (generation !== this.generation || !this.isConnected) return;
            this.failed.add(next);
            this.dots[next].hidden = true;
            continue;
          }
          if (generation !== this.generation || !this.canPlay()) return;
          this.slides[this.index].classList.remove('is-active');
          this.dots[this.index].classList.remove('is-active');
          this.slides[next].classList.add('is-active');
          this.dots[next].classList.add('is-active');
          this.index = next;
          this.schedule();
          return;
        }
        this.paused = true;
        this.button.hidden = true;
        this.querySelector('.rd-designs__dots').hidden = true;
      }
      disconnectedCallback() { this.generation += 1; this.controller?.abort(); this.observer?.disconnect(); clearTimeout(this.timer); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
